__turbopack_context__.v({
  "className": "figtree_edac8f00-module__T-8Vta__className",
});
